import { Box, Stack, styled, Text } from '@/theme/index';

interface MarketDataSectionProps {
  marketData: {
    icon: JSX.Element;
    title: string;
    value: string;
  }[];
}

const StyledContainer = styled(Stack)({
  boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
  borderRadius: 0.4,
  marginBottom: '1.5rem',
  padding: '.75rem 1rem',
});

export const MarketDataSection = ({ marketData }: MarketDataSectionProps) => {
  return (
    <StyledContainer
      className="market-analysis-container"
      data-cy="market-data-section"
    >
      <Stack
        flexDirection={{ xs: 'column', sm: 'row' }}
        flexWrap="wrap"
        spacing={1}
      >
        {marketData?.map(({ icon, title, value }) => (
          <Stack
            data-cy="market-data-item"
            key={title}
            flexDirection="row"
            alignItems="center"
            width={{ xs: '100%', sm: '50%' }}
          >
            <Box mr={0.75}>{icon}</Box>
            <Text variant="body1">
              <Text fontWeight="bold" display="inline">
                {title}:
              </Text>{' '}
              {value}
            </Text>
          </Stack>
        ))}
      </Stack>
    </StyledContainer>
  );
};
